// @flow

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { css } from 'glamor';
import { Col, Row, Grid } from 'react-bootstrap';

import SocialBar from '~/components/global/SocialBar';
import BrowseMenu from '~/components/global/BrowseMenu';
import ContributorList from '~/components/global/ContributorList';
import Title from '~/components/global/Title';

import type { User, MenuEntry } from '~/types';

const container = css({
    minHeight: '390px',
    paddingTop: '20px',
    backgroundColor: 'rgb(51, 51, 51)',
    borderTop: '5px solid rgb(228, 65, 34)',
    color: '#fff',
});

const paragraph = css({
    lineHeight: '23px',
});

const title = css({
    marginTop: '15px',
    marginBottom: '15px',
});

const logo = css({
    position: 'relative',
    marginLeft: '-55px',
    marginTop: '-35px',
    marginBottom: '-35px',
    height: '150px',
});

const button = css({
    marginTop: '20px',
});

const contributorsRule = css({
    marginLeft: 0,

    '@media(max-width: 768px)': {
        marginTop: '-20px',
    },
});

const contributorList = css({
    paddingLeft: 0,
});

const content = css({
    marginTop: '25px',

    '@media(max-width: 768px)': {
        marginTop: '0',
    },
});

const copyrightLink = css({
    color: '#fff',
    fontWeight: 400,

    ':hover': {
        color: '#fff',
    },
});

const sectionSpacer = css({
    '@media(max-width: 768px)': {
        marginTop: '20px',
    },
});

@observer
export default class Footer extends Component {
    props: {
        contributors: Array<User>,
        entries: Array<MenuEntry>,
        platforms: Array<MenuEntry>,
    };

    render() {
        const { contributors, entries, platforms } = this.props;

        return (
            <div { ...container }>
                <footer>
                    <Grid>
                        <Row>
                            <Col md={ 4 }>
                                <h4 { ...title }>
                                    <Title boldText="ABOUT" normalText=" US" />
                                </h4>
                                <div { ...content }>
                                    <img
                                        { ...logo }
                                        src="/assets/images/logo.svg"
                                    />
                                    <p { ...paragraph }>
                                        {/*  eslint-disable max-len */}
                                        {
                                            'Supagemu.com is the expression of our passion for retro import gaming. We have played video games since the late 80s and we feel especially nostalgic about the 8-bit/16-bit era, when the Famicom, PC Engine, Mega Drive, Super Famicom, Neo Geo, etc. coexisted, and when import gaming was just getting started.'
                                        }
                                        {/*  eslint-enable max-len */}
                                    </p>
                                    <div { ...button }>
                                        {/* <Button
                                            label='CONTACT US'
                                        /> */}
                                        <SocialBar />
                                    </div>
                                </div>
                            </Col>
                            <Col md={ 4 } { ...sectionSpacer }>
                                <h4>
                                    <Title boldText="BROWSE" />
                                </h4>
                                <div { ...content }>
                                    <Row>
                                        <Col md={ 6 }>
                                            <BrowseMenu
                                                entries={ entries }
                                                icon="caret-right"
                                            />
                                        </Col>
                                        <Col md={ 6 }>
                                            <BrowseMenu
                                                entries={ platforms }
                                                icon="gamepad"
                                            />
                                        </Col>
                                    </Row>
                                    <a
                                        { ...copyrightLink }
                                        href="https://www.copyrightdepot.com/showCopyright.php?lang=FR&amp;id=587"
                                    >
                                        {'Copyrighted content.'}
                                    </a>
                                    <p>
                                        {/*  eslint-disable max-len */}
                                        {
                                            'All the reviews are intellectually protected. Plagiarism will not be tolerated.'
                                        }
                                        {/*  eslint-enable max-len */}
                                    </p>
                                </div>
                            </Col>
                            <Col md={ 4 } { ...sectionSpacer }>
                                <h4>
                                    <Title
                                        boldText="OUR"
                                        normalText=" CONTRIBUTORS"
                                    />
                                </h4>
                                <div { ...content }>
                                    <div { ...contributorsRule }>
                                        <ContributorList
                                            contributors={ contributors }
                                            { ...contributorList }
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </footer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js